import { Flex, Text, VStack } from '@chakra-ui/react';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { DataPipeline } from '@finley-technologies/finley-types';

import { colors } from 'packages/common-frontend/colors';
import { Icon as FaIcon } from 'packages/common-frontend/components/icons';

type StatusIconProps = {
  background: string;
  icon: string;
  label: string;
  textColor: string;
};

const statusStyles: {
  [key in DataPipeline.Status]: StatusIconProps;
} = {
  success: {
    background: colors.green[100],
    icon: 'check-circle',
    label: 'Complete',
    textColor: colors.green[400],
  },
  error: {
    background: colors.red[100],
    icon: 'circle-xmark',
    label: 'Error',
    textColor: colors.red[400],
  },
  inProgress: {
    background: colors.blue[100],
    icon: 'spinner',
    label: 'In Progress',
    textColor: colors.blue[400],
  },
  waitingForAssignment: {
    background: colors.orange[100],
    icon: 'circle-exclamation',
    label: 'Assignment Required',
    textColor: colors.orange[400],
  },
  waitingForInput: {
    background: colors.orange[100],
    icon: 'circle-exclamation',
    label: 'Inputs Required',
    textColor: colors.orange[400],
  },
  waitingForVerificationApproval: {
    background: colors.orange[100],
    icon: 'circle-exclamation',
    label: 'Verification Required',
    textColor: colors.orange[400],
  },
  expired: {
    background: colors.gray[100],
    icon: 'calendar-circle-exclamation',
    label: 'Expired',
    textColor: colors.gray[400],
  },
};

export const PipelineStatusIndicator = ({
  status,
}: {
  status: DataPipeline.Status;
}) => {
  const styles = statusStyles[status];
  finleyAssert(styles, `Unknown pipeline status:${status}`);

  return (
    <Flex
      as="span"
      height="100%"
      padding="7px 12px"
      background={styles.background}
      borderRadius="7px"
      display="inline-flex"
      alignItems="center"
      gap={2}
      color="white"
      whiteSpace="nowrap"
    >
      <FaIcon icon={styles.icon} color={styles.textColor} />
      <Text as="span" color={styles.textColor} size="14px">
        {styles.label}
      </Text>
    </Flex>
  );
};

export const getStatusIcon = (status: DataPipeline.Status): StatusIconProps => {
  const styles = statusStyles[status];
  return styles;
};

export const getStatusText = (status: DataPipeline.Status): StatusIconProps => {
  const styles = statusStyles[status];
  return styles;
};

export const TestRender = () => {
  return (
    <VStack>
      {DataPipeline.StatusIterables.map((status) => {
        return <PipelineStatusIndicator key={status} status={status} />;
      })}
    </VStack>
  );
};
